<template>
<ContentWrapper>
    <div class="content-heading">
      <div>이슈톡 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/community/issueTalkList">이슈톡 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search"/>
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
              <b-input-group class="mt-2 mb-1">
                <div class="form-check mb-2">
                  <input class="form-check-input" :id="`user-type-all`" v-model="data.selectAllUserType"
                    value="" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-all`">전체</label>
                </div>
                <div v-for="(item, index) in contentsUserTypes.array" :key="index" class="form-check mb-2 ml-3">
                  <input class="form-check-input" :id="`user-type-${index}`" v-model="data.selectedUserTypes" 
                    :value="item.value" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-${index}`">{{item.text}}</label>
                </div>
              </b-input-group>
            </div>

            <div class="col-auto">
              <label class="col-form-label">대상</label>
            </div>
            <div class="col-auto">
              <b-form-select :options="data.issueTargetOption.array" v-model="data.params.issueTargetCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">설문 유형</label>
            </div>
            <div class="col-auto">
              <b-form-select :options="data.issueTypeOption.array" v-model="data.params.issueTypeCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">상태</label>
            </div>
            <div class="col-auto">
              <b-form-select :options="data.statusOption.array" v-model="data.params.status" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">신고 여부</label>
            </div>
            <div class="col-auto">
              <b-form-select :options="data.warnOption.array" v-model="data.params.warnYn" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="7%" style="text-align:center" >채널</td>
              <td width="7%" style="text-align:center" >설문유형</td>
              <td width="10%" style="text-align:center" >대상</td>
              <td style="text-align:center" @click="localSort.sort('title')" >주제<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" >상태</td>
              <td width="17%" style="text-align:center" >기간</td>
              <td width="13%" style="text-align:center" @click="localSort.sort('regDt')" >등록일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" >신고</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="8">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{contentsUserTypes.getText(item.typeCd)}}</td>
                <td class="align-middle text-center">{{data.issueTypeOption.getText(item.issueTypeCd)}}</td>
                <td class="align-middle text-center">{{data.issueTargetOption.getText(item.issueTargetCd)}}</td>
                <td class="align-middle text-center">{{item.title}}</td>
                <td class="align-middle text-center">{{item.status}}</td>
                <td class="align-middle text-center">{{item.startDt}} ~<br/> {{item.endDt}}</td>
                <td class="align-middle text-center">{{item.regDt}}</td>
                <td class="align-middle text-center">{{data.warnOption.getText(item.warnYn)}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, contentsUserTypes, ValueTexts, warnCommentTopicOption} from "@/utils/Constants";
import * as comApi from "@/api/community/CommunityAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
      _dataObject.selectAllUserType = computed({
        get() {
          return data.selectedUserTypes.length == contentsUserTypes.array.length;
        },
        set(newValue) {
          if (newValue) {
            data.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
          } else {
            data.selectedUserTypes = [];
          }
        }
      });
      const data = reactive(_dataObject);
      console.log('data.selectedUserTypes:', data.selectedUserTypes);

      data.topicOption = warnCommentTopicOption;
      data.schOptions = [
        {value:'title', text:'제목'},
      ];

      data.issueTargetOption = new ValueTexts([
        {value:'', text:'전체'},
        {value:'338001', text:'초/중/고 공통'},
        {value:'338002', text:'초등'},
        {value:'338003', text:'중등'},
        {value:'338004', text:'고등'},
      ]);
      data.issueTypeOption = new ValueTexts([
        {value:'', text:'전체'},
        {value:'337001', text:'찬반'},
        {value:'337002', text:'선택'},
        {value:'337003', text:'메모'},
      ]);
      data.statusOption = new ValueTexts([
        {value:'', text:'전체'},
        {value:'before', text:'예정'},
        {value:'after', text:'종료'},
        {value:'now', text:'진행'},
      ]);
      data.warnOption = new ValueTexts([
        {value:'', text:'전체'},
        {value:'Y', text:'신고'},
        {value:'N', text:'미신고'},
      ]);

      const retVals = {
        isTest,
        modalLoading,
        contentsUserTypes,
        data,
        ...methods(data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        await retVals.resetSearch();
      });

      return retVals;
    }
}

function methods(data) {

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:',data);

    data.params.issueTargetCd = '';
    data.params.issueTypeCd = '';
    data.params.status = '';
    data.params.warnYn = '';
    data.params.schType = '';
    data.params.schText = '';
  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    // typeCd 설정
    if (data.selectedUserTypes.length == 1) {
      data.params.typeCd = data.selectedUserTypes[0];
    } else {
      // length == 2 인 경우에도 '' 로 해서 전체 검색으로 전달한다.
      data.params.typeCd = '';
    }

    const result = await comApi.getIssueTalkList(data.params, this.isTest);
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  return {
    resetSearch,
    reset,
    search,
  }
}
</script>